var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"nav nav-mobile-menu"},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"/login"},on:{"click":function($event){$event.preventDefault();return _vm.logout()}}},[_c('span',{staticClass:"text-white"},[_vm._v("Salir")]),_c('i',{staticClass:"bi bi-door-open-fill ml-1 text-white"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }